<template>
  <div>
    <div class="Fuell-Toolbar">
      <entity-search-input @search="fetchUsers"></entity-search-input>
    </div>
    <users-social-benefits-table
      :columns="columns"
      @showRequestSalaryModal="showRequestSalaryModal"
      @showConfirmDeactivationModal="showConfirmDeactivationModal($event)"
    ></users-social-benefits-table>
    <user-request-gross-salary-modal
      :open.sync="showRequestGrossSalaryModalFlag"
      :featureData="featureData"
      v-if="showRequestGrossSalaryModalFlag"
    ></user-request-gross-salary-modal>
    <confirm-modal
      v-if="showConfirmDeactivationModalFlag"
      :open.sync="showConfirmDeactivationModalFlag"
      :featureData="featureData"
      :title="'benefits_confirm_subvention_deactivation_with_accumulative_subvention'"
      :acceptText="'benefits_confirm_acumulation_removal_action_confirm'"
      :message="''"
      :dismissText="'ACTION_CANCEL'"
      @accept="confirmSetFeature"
    >
      <template v-slot:additional>
        <p class="Fuell-Text text-center">
          <i18n path="benefits_confirm_acumulation_remove_warning"></i18n>
        </p>
      </template>
    </confirm-modal>

  </div>
</template>

<script>
import EntitySearchInput from '@/components/Commons/Search/EntitySearchInput'
import UsersSocialBenefitsTable from '../../_components/users/socialBenefits/UsersSocialBenefitsTable'

import _userBenefitsIndexHandler from '../../_mixins/_userBenefitsIndexHandler'
import _benefitsSharedMethods from '../../_mixins/_benefitsSharedMethods'
const UserRequestGrossSalaryModal = () => import('../../_components/users/UserRequestGrossSalaryModal')
const ConfirmModal = () => import('@/components/Commons/ConfirmModal')

export default {
  name: 'UserSocialBenefitsIndex',
  mixins: [_userBenefitsIndexHandler, _benefitsSharedMethods],
  components: {
    EntitySearchInput,
    UsersSocialBenefitsTable,
    UserRequestGrossSalaryModal,
    ConfirmModal
  },
  computed: {
    columns () {
      return this.$store.getters['BenefitsStore/subventionColumns'].filter(el => {
        if (this.isImpersonating) {
          return el
        } else {
          return !el.superAdminOnly
        }
      }).map(el => {
        if (el.key.includes('current') && !el.key.includes('insurance') && !el.key.includes('education') && !el.key.includes('nursery')) {
          return {
            key: el.key,
            name: this.generateColumnLabel(el.key),
            visible: el.visible,
            modifiable: el.modifiable,
            template: el.template
          }
        } else {
          return el
        }
      })
    }

  },
  methods: {
    showRequestSalaryModal (event) {
      this.featureData = event
      this.showRequestGrossSalaryModalFlag = true
    },
    showConfirmDeactivationModal (event) {
      this.featureData = event
      this.showConfirmDeactivationModalFlag = true
    },
    confirmSetFeature () {
      const { id, feature } = this.featureData
      this.setUserFeature(id, feature)
    }

  },
  data () {
    return {
      showRequestGrossSalaryModalFlag: false,
      showConfirmDeactivationModalFlag: false,
      featureData: {}
    }
  },
  async created () {
    this.$store.dispatch('UsersStore/clearStore')
    await this.fetchUsers()
  },
  beforeCreate () {
    this.$store.dispatch('BenefitsStore/initializeSubventionColumns')
  }

}
</script>

<style>
.benefits-large-dropdown .Fuell-Dropdown--container {
  position: absolute;
  width: 330px;
  max-width: 350px;
  text-align: left;
}
.benefits-large-dropdown .list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row-reverse;

  margin: 10px 0px;
}
.benefits-large-dropdown .list-item .icon {
  margin-right: 10px;
}
</style>
